import basicRequest from "../../../core/redux/actions/request";

const PREFIX = "QUOTE_FORM";
const getState = (state) => state.quote.form;

const {
    reset,

    getPattern,
    getEmptyRequestPattern,
    secondaryPostPattern,
    secondaryPutPattern,

    isLoaded,
    isLoading,
    getError,
    getData,
    getSecondaryData,
    getSecondarySuccess: getFormSuccess,
} = basicRequest(PREFIX, getState);

export const load = (id) => {
    if (id == null) {
        return getEmptyRequestPattern();
    }

    const url = "react/quotes/v1/form/" + id;

    return getPattern(url, {});
};

export const loadCsv = (id) => {
    const url = "react/quotes/v1/form-csv/" + id;

    return getPattern(url, {});
};

export const loadXtm = (id) => {
    if (id == null) {
        return getEmptyRequestPattern();
    }

    const url = "react/quotes/v1/form-xtm/" + id;

    return getPattern(url, {});
};

export const create = (form) =>
    secondaryPostPattern("react/quotes/v1/form", form, {
        message: "Created",
        description: "The Quote was created",
    });

export const update = (id, form) =>
    secondaryPutPattern("react/quotes/v1/form/" + id, form, {
        message: "Updated",
        description: "The Quote was updated",
    });

export const updateCsv = (id, form) =>
    secondaryPutPattern("react/quotes/v1/receivables/" + id + "/form", form, {
        message: "Updated",
        description: "The Quote was updated",
    });

export const updateXtm = (id, form) =>
    secondaryPutPattern("react/quotes/v1/finance-xtm/" + id + "/form", form, {
        message: "Updated",
        description: "The Quote was updated",
    });

export { reset, getData, isLoaded, isLoading, getError, getSecondaryData, getFormSuccess };
